import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SalesReportaContent from '../SalesReportaContent';
import { setFromDate, setToDate, setSelectedBranch, fetchSalesReportaData } from '../../../store/slices/salesReportaSlice';

const SalesReporta = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        dispatch(
            fetchSalesReportaData({
                fromDate,
                toDate,
                branchId: storedBranchId || 'All'
            })
        );
    }, [dispatch, storedBranchId]);

    return <SalesReportaContent />;
};

export default SalesReporta;
